
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="行序号问题" fileName="row-index.md" />
        <p>开启虚拟滚动后，行号可以通过服务端返回。如果表格存在客户端查询的情况，需要需要我们做一些处理。具体见下面示例</p>
<demo-block>
        <div><p>1、滚动时会触发<code>scrolling({ startRowIndex, visibleStartIndex, visibleEndIndex, visibleAboveCount, visibleBelowCount})</code>。<code>startRowIndex</code>为当前开始渲染的行号，<code>visibleStartIndex</code>为当前可见区域的开始行号，<code>visibleEndIndex</code>为当前可见区域的结束行号，<code>visibleAboveCount</code>为当前可见区域上方渲染的数量，<code>visibleBelowCount</code>为当前可见区域下方渲染的数量<br>2、通过<code>scrolling</code>方法结合<code>renderBodyCell({ row, column, rowIndex })</code>方法返回的<code>rowIndex</code> 算出当前虚拟滚动的真实序号，为<code>rowIndex + startRowIndex + 1</code></p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;div&gt;
        &lt;el-input style=&quot;width:250px&quot; v-model=&quot;searchValue&quot; placeholder=&quot;search name&quot;&gt;&lt;/el-input&gt;
        &lt;el-button type=&quot;primary&quot; @click=&quot;search&quot;&gt;Search&lt;/el-button&gt;
        &lt;br /&gt;
        &lt;br /&gt;
        &lt;ve-table
            :max-height=&quot;500&quot;
            :virtual-scroll-option=&quot;virtualScrollOption&quot;
            :columns=&quot;columns&quot;
            :table-data=&quot;tableData&quot;
            row-key-field-name=&quot;rowKey&quot;
        /&gt;
    &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
    import Mock from &quot;mockjs&quot;;
    export default {
        data() {
            return {
                // search value
                searchValue: &quot;&quot;,
                // start row index
                startRowIndex: 0,
                virtualScrollOption: {
                    // 是否开启
                    enable: true,
                    scrolling: this.scrolling,
                },
                // columns
                columns: [
                    {
                        field: &quot;index&quot;,
                        key: &quot;index&quot;,
                        title: &quot;#&quot;,
                        width: 200,
                        align: &quot;left&quot;,
                        renderBodyCell: this.renderRowIndex,
                    },
                    {
                        field: &quot;name&quot;,
                        key: &quot;name&quot;,
                        title: &quot;Name&quot;,
                        width: 200,
                        align: &quot;left&quot;,
                    },
                    {
                        field: &quot;hobby&quot;,
                        key: &quot;hobby&quot;,
                        title: &quot;Hobby&quot;,
                        width: 300,
                        align: &quot;left&quot;,
                    },
                    {
                        field: &quot;address&quot;,
                        key: &quot;address&quot;,
                        title: &quot;Address&quot;,
                        width: &quot;&quot;,
                        align: &quot;left&quot;,
                    },
                ],
                // real table data
                tableData: [],
                // source data
                sourceData: [],
            };
        },
        methods: {
            // virtual scrolling
            scrolling({
                startRowIndex,
                visibleStartIndex,
                visibleEndIndex,
                visibleAboveCount,
                visibleBelowCount,
            }) {
                this.startRowIndex = startRowIndex;
                console.log(&quot;startRowIndex::&quot;, startRowIndex);
                console.log(&quot;visibleStartIndex::&quot;, visibleStartIndex);
                console.log(&quot;visibleEndIndex::&quot;, visibleEndIndex);
                console.log(&quot;visibleAboveCount::&quot;, visibleAboveCount);
                console.log(&quot;visibleBelowCount::&quot;, visibleBelowCount);
            },
            // render row index
            renderRowIndex({ row, column, rowIndex }) {
                return (
                    &lt;span class=&quot;text-bold&quot; style=&quot;color:#1890ff;&quot;&gt;
                        {rowIndex + this.startRowIndex + 1}
                    &lt;/span&gt;
                );
            },

            // search
            search() {
                const searchValue = this.searchValue;
                this.tableData = this.sourceData.filter(
                    (x) =&gt;
                        !searchValue.length ||
                        x.name.toLowerCase().includes(searchValue.toLowerCase()),
                );
            },

            initData() {
                let data = [];
                for (let i = 0; i &lt; 1000; i++) {
                    data.push({
                        rowKey: i,
                        name: Mock.Random.name(),
                        hobby: `hobby`,
                        address: `address`,
                    });
                }

                this.sourceData = data;
                this.tableData = this.sourceData.slice(0);
            },
        },
        created() {
            this.initData();
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        import Mock from "mockjs";
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('el-input',{staticStyle:{"width":"250px"},attrs:{"placeholder":"search name"},model:{value:(_vm.searchValue),callback:function ($$v) {_vm.searchValue=$$v},expression:"searchValue"}}),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.search}},[_vm._v("Search")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('ve-table',{attrs:{"max-height":500,"virtual-scroll-option":_vm.virtualScrollOption,"columns":_vm.columns,"table-data":_vm.tableData,"row-key-field-name":"rowKey"}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                // search value
                searchValue: "",
                // start row index
                startRowIndex: 0,
                virtualScrollOption: {
                    // 是否开启
                    enable: true,
                    scrolling: this.scrolling,
                },
                // columns
                columns: [
                    {
                        field: "index",
                        key: "index",
                        title: "#",
                        width: 200,
                        align: "left",
                        renderBodyCell: this.renderRowIndex,
                    },
                    {
                        field: "name",
                        key: "name",
                        title: "Name",
                        width: 200,
                        align: "left",
                    },
                    {
                        field: "hobby",
                        key: "hobby",
                        title: "Hobby",
                        width: 300,
                        align: "left",
                    },
                    {
                        field: "address",
                        key: "address",
                        title: "Address",
                        width: "",
                        align: "left",
                    },
                ],
                // real table data
                tableData: [],
                // source data
                sourceData: [],
            };
        },
        methods: {
            // virtual scrolling
            scrolling({
                startRowIndex,
                visibleStartIndex,
                visibleEndIndex,
                visibleAboveCount,
                visibleBelowCount,
            }) {
                this.startRowIndex = startRowIndex;
                console.log("startRowIndex::", startRowIndex);
                console.log("visibleStartIndex::", visibleStartIndex);
                console.log("visibleEndIndex::", visibleEndIndex);
                console.log("visibleAboveCount::", visibleAboveCount);
                console.log("visibleBelowCount::", visibleBelowCount);
            },
            // render row index
            renderRowIndex({ row, column, rowIndex }) {
                return (
                    <span class="text-bold" style="color:#1890ff;">
                        {rowIndex + this.startRowIndex + 1}
                    </span>
                );
            },

            // search
            search() {
                const searchValue = this.searchValue;
                this.tableData = this.sourceData.filter(
                    (x) =>
                        !searchValue.length ||
                        x.name.toLowerCase().includes(searchValue.toLowerCase()),
                );
            },

            initData() {
                let data = [];
                for (let i = 0; i < 1000; i++) {
                    data.push({
                        rowKey: i,
                        name: Mock.Random.name(),
                        hobby: `hobby`,
                        address: `address`,
                    });
                }

                this.sourceData = data;
                this.tableData = this.sourceData.slice(0);
            },
        },
        created() {
            this.initData();
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  